window.c24DomReady(function() {
    const links = document.querySelectorAll('.imageBulletList .vcVplusLink');

    const triggerTracking = actionName => {
        window._paq.push([
            'trackEvent',
            window.c24Lp.getMatomoEventCategory(),
            'landing_page_vc_vplus',
            `lp_${actionName}_clicked`,
        ]);
    };

    for (const link of links) {
        link.addEventListener('click', () => {
            const action = link.getAttribute('data-action');
            triggerTracking(action);
        });
    }
});
